import { Card, CardContent, Typography } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import "./Card.sass";

type DashboardCardProps = {
  image: React.ComponentType<SvgIconProps> | React.FunctionComponent<any>;
  title: string;
  description: string;
  linkText: string;
  onClickLink: () => any;
};

const DashboardCard = (props: DashboardCardProps) => (
  <Card className="dashboard-card dashboard__fadeInRight ">
    <div className="dashboard__fade">
      <div className="dashboard-card__icon">
        <props.image className="dashboard-card__icon" />
      </div>
      <div className="dashboard-card__header">
        <Typography
          className="dashboard-card__title"
          variant="body1"
          component="h2"
        >
          {props.title}
        </Typography>
      </div>
      <CardContent className="dashboard-card__description">
        <div>
          <Typography variant="caption" component="p" className="content">
            {props.description}
          </Typography>
        </div>
      </CardContent>
      <div className="dashboard-card__actions">
        <Typography
          onClick={props.onClickLink}
          className="dashboard-card__link"
          variant="caption"
          id={`lob-entry-${toKebabCase(props.title)}`}
        >
          {props.linkText}
          <i
            className="fa fa-chevron-right dashboard-card__link-icon"
            aria-hidden="true"
          />
        </Typography>
      </div>
    </div>
  </Card>
);

export default DashboardCard;
